
/* injects from baggage-loader */

'use strict';

const indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item)  {
      return i;
    }
  }
  return -1;
};

const subscribeFormFieldsDirective = angular.module('subscribeFormfields.setting', []);

subscribeFormFieldsDirective.filter('toArray', ['$timeout', ($timeout) => {
  return function(obj) {
    var result;
    result = [];
    _.each(obj, function(val, hash) {
      return result.push({
        name: val,
        value: hash
      });
    });
    return result;
  };
}
]);

subscribeFormFieldsDirective.directive('subscribeFormFieldsSetting', [
  '$window', '$timeout', '$compile', '$templateCache', 'ns', 'translitService', 'ContentEditable', 'Widget', 'blockEditDialog', '$rootScope', '$filter',
  ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, $rootScope, $filter) => {
    return {
      restrict: 'A',
      scope: {
        data: '=ngModel'
      },
      templateUrl: settingFolder + '/subscribeFormfields/template.jade',
      link: (scope, element, attrs, ngModel) => {
        const {widgetId} = attrs;
        const widgetElWrapper = angular.element(`[data-block-id=${widgetId}]`).find(ns.widgetWrapperClass);

        const DIGITAL_PRODUCT = 0;
        const PHYSICAL_PRODUCT = 1;
        const FLOATING_PRICE_PRODUCT = 2;
        const NAME_FIELD = 'lead_name';
        const EMAIL_FIELD = 'lead_email';
        const USER_FIELDS = [
          'lead_phone',
          'lead_middle_name',
          'lead_last_name',
          'lead_city',
          'lead_offert',
          'orderData[offerta_accept]'
        ];
        const PRODUCT_PRICE_FIELD = 'product_price';
        const SUM_FIELD = 'orderData[bill_sum]';
        const KUPON_FIELD = 'orderData[bill_kupon]';
        const ADDRESS_FIELD = 'orderData[bill_hide_shipping_address]';
        const ADDRESS_FIELDS = [
          'orderData[bill_billing_country]',
          'orderData[bill_billing_address]',
          'orderData[bill_billing_address2]',
          'orderData[bill_billing_city]',
          'orderData[bill_billing_state]',
          'orderData[bill_billing_zip]'
        ];
        const DELIVERY_ADDRESS_FIELDS = [
          'orderData[bill_shipping_name]',
          'orderData[bill_shipping_phone]',
          'orderData[bill_country]',
          'orderData[bill_address]',
          'orderData[bill_address2]',
          'orderData[bill_city]',
          'orderData[bill_region]',
          'orderData[bill_postal_code]',
        ];
        const STRIPE_FIELD = 'stripe';
        const CLOUD_PAYMENTS_FIELD = 'cloudpayments';
        const CONTACT_INFO_FIELD = 'contact_info';

        const stripeEnabled = !!window.justclick.isStripeEnabled;
        const cloudpaymentEnabled = !!window.justclick.isCloudPaymentsEnabled;
        const ignoreSelectedProducts = !!window.justclick.ignoreSelectedProducts;
        const disableChangeEmailField = !!window.justclick.disableChangeEmailField;
        const disableChangeStripeField = stripeEnabled && ignoreSelectedProducts;
        const disableChangeCloudpaymentField = cloudpaymentEnabled && ignoreSelectedProducts;

        /**
         * findFieldIndexByAttr
         * @param fields
         * @param attribute
         * @returns {*}
         */
        const findFieldIndexByAttr = (fields, attribute) => {
          const field = _.filter(fields, attribute)[0];
          return fields.indexOf(field);
        };

        /**
         * findFieldByAttr
         * @param fields
         * @param attribute
         * @returns {null|*}
         */
        const findFieldByAttr = (fields, attribute) => {
          const index = findFieldIndexByAttr(fields, attribute);

          if (index > -1) {
            return fields[index];
          } else {
            return null;
          }
        };

        const fieldExist = function(field_) {
          var field, j, len1, ref;
          ref = scope.form.form_fields_attributes;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            field = ref[j];
            if (field_.name === field.name) {
              return true;
            }
          }
          return false;
        };

        let newFieldsAdded = false;
        // todo: Впоследствии удалить, либо преобразовать в отедельный класс
        // Генерация полей для формы, чтобы поддержать обратную совместимость
        // Обновляет массив scope.data.form_fields_attributes
        (function() {
          const genDefaultField = (type, name, placeholder, title, show, exist, invisible) => {
            return {
              checked: true,
              invisible: invisible,
              disable: false,
              exist: exist,
              field_type: type,
              hidden: false,
              link_href_target: 'blank',
              name: name,
              offert: false,
              offert_target_blank: false,
              offert_text: '',
              offert_url: 'http://',
              offert_url_text: '',
              options_countries: '',
              options_created: false,
              options_raw: null,
              options_states_of_usa: '',
              placeholder: placeholder,
              required: true,
              show: show,
              title: title,
              unique: false,
              validation: false,
              value: ''
            };
          };
          const indexAddressField = findFieldIndexByAttr(scope.data.form_fields_attributes, {name: ADDRESS_FIELD});
          const addressField = scope.data.form_fields_attributes[indexAddressField];
          const addressFieldExist = addressField.exist;
          const deliveryFields = [{
              type: 'text',
              name: ADDRESS_FIELDS[2],
              placeholder: $filter('translate')('widget.form.your_apt'),
              title: $filter('translate')('widget.form.address_2'),
              exist: false,
              invisible: false,
              show: true
            },{
              type: 'text',
              name: DELIVERY_ADDRESS_FIELDS[0],
              placeholder: $filter('translate')('widget.form.lead_name_placeholder'),
              title: $filter('translate')('widget.form.shipping_name'),
              exist: false,
              invisible: true,
              show: false
            },{
              type: 'text',
              name: DELIVERY_ADDRESS_FIELDS[1],
              placeholder: $filter('translate')('widget.form.lead_phone_placeholder'),
              title: $filter('translate')('widget.form.shipping_phone'),
              exist: false,
              invisible: true,
              show: false
            },{
              type: 'select',
              name: DELIVERY_ADDRESS_FIELDS[2],
              placeholder: $filter('translate')('widget.form.country'),
              title: $filter('translate')('widget.form.shipping_country'),
              exist: false,
              invisible: true,
              show: false
            }, {
              type: 'text',
              name: DELIVERY_ADDRESS_FIELDS[3],
              placeholder: $filter('translate')('widget.form.your_street'),
              title: $filter('translate')('widget.form.shipping_address_1'),
              exist: false,
              invisible: true,
              show: false
            }, {
              type: 'text',
              name: DELIVERY_ADDRESS_FIELDS[4],
              placeholder: $filter('translate')('widget.form.your_apt'),
              title: $filter('translate')('widget.form.shipping_address_2'),
              exist: false,
              invisible: true,
              show: false
            }, {
              type: 'text',
              name: DELIVERY_ADDRESS_FIELDS[5],
              placeholder: $filter('translate')('widget.form.city_placeholder'),
              title: $filter('translate')('widget.form.shipping_city'),
              exist: false,
              invisible: true,
              show: false
            }, {
              type: 'text',
              name: DELIVERY_ADDRESS_FIELDS[6],
              placeholder: $filter('translate')('widget.form.state_placeholder'),
              title: $filter('translate')('widget.form.shipping_state'),
              exist: false,
              invisible: true,
              show: false
            }, {
              type: 'text',
              name: DELIVERY_ADDRESS_FIELDS[7],
              placeholder: $filter('translate')('widget.form.zip_placeholder'),
              title: $filter('translate')('widget.form.shipping_zip'),
              exist: false,
              invisible: true,
              show: false
            }
          ];

          deliveryFields.map((field) => {
            let {type, name, exist, show, placeholder, title, invisible} = field;

            if (addressFieldExist && DELIVERY_ADDRESS_FIELDS.includes(name)) {
              show = true;
              exist = true;
            }

            if (findFieldIndexByAttr(scope.data.form_fields_attributes, {name}) === -1) {
              const field = genDefaultField(type, name, placeholder, title, show, exist, invisible);

              scope.data.form_fields_attributes.push(field);
              newFieldsAdded = true;
            }
          });
        })();

        /**
         * Селект групп
         * todo: Впоследствии оптимизировать код, текущий вариант это прямое преобразование coffee script в js практически без рефакторинга
         * @param type
         * @returns {*[]}
         */
        const setSelectedOldGroups = function(type) {
          let group, oc, ocgroup, oldcategory;

          const oldCategories = angular.copy(scope.data[type]);
          scope.data[type] = angular.copy(window.justclick.formCategories);
          const ref = scope.data[type];

          let results = [];
          for (let i = 0, len = ref.length; i < len; i++) {
            oldcategory = ref[i];
            results.push((function() {
              const ref1 = oldcategory.groups;
              let results1 = [];
              for (let j = 0, len1 = ref1.length; j < len1; j++) {
                group = ref1[j];
                results1.push((function() {
                  let results2 = [];
                  for (let k = 0, len2 = oldCategories.length; k < len2; k++) {
                    oc = oldCategories[k];
                    results2.push((function() {
                      const ref2 = oc.groups;
                      let results3 = [];
                      for (let l = 0, len3 = ref2.length; l < len3; l++) {
                        ocgroup = ref2[l];
                        if (group.name === ocgroup.name && ocgroup.selected) {
                          results3.push(group.selected = true);
                        } else {
                          results3.push(void 0);
                        }
                      }
                      return results3;
                    })());
                  }
                  return results2;
                })());
              }
              return results1;
            })());
          }
          return results;
        };

        /**
         * Заполним поля с странами данными
         * @param indexCountry
         * @param countries
         */
        const updateCountries = function(indexCountry, countries) {
          if (indexCountry > 0) {
            scope.data.form_fields_attributes[indexCountry].options_raw = '';

            for (let i = 0, len = countries.length; i < len; i++) {
              const country = countries[i];
              if (country.title) {
                scope.data.form_fields_attributes[indexCountry].options_raw += '\n' + country.title;
              }
            }

            scope.data.form_fields_attributes[indexCountry].options_countries = JSON.stringify(countries);
          }
        };

        /**
         * Заполним поля с штатами данными
         * @param indexState
         * @param states
         */
        const updateStates = function(indexState, states) {
          if (indexState > -1) {
            scope.data.form_fields_attributes[indexState].options_states_of_usa = JSON.stringify(states);
          }
        };

        const indexCountry = findFieldIndexByAttr(scope.data.form_fields_attributes, {name: ADDRESS_FIELDS[0]});
        const indexDeliveryCountry = findFieldIndexByAttr(scope.data.form_fields_attributes, {name: DELIVERY_ADDRESS_FIELDS[2]});
        const indexState = findFieldIndexByAttr(scope.data.form_fields_attributes, {name: ADDRESS_FIELDS[4]});
        const indexDeliveryState = findFieldIndexByAttr(scope.data.form_fields_attributes, {name: DELIVERY_ADDRESS_FIELDS[6]});

        updateCountries(indexCountry, window.justclick.countries);
        updateCountries(indexDeliveryCountry, window.justclick.countries);

        updateStates(indexState, window.justclick.statesOfUSA);
        updateStates(indexDeliveryState, window.justclick.statesOfUSA);

        if (scope.data.categories && scope.data.categories.length === 0) {
          scope.data.categories = angular.copy(window.justclick.formCategories);
        } else {
          // Выбор групп для добавления
          setSelectedOldGroups('categories');
        }

        if (scope.data.ex_categories.length === 0) {
          scope.data.ex_categories = angular.copy(window.justclick.formCategories);
        } else {
          // Выбор групп для удаления
          setSelectedOldGroups('ex_categories');
        }

        scope.form = angular.copy(scope.data);

        const getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.form.form_fields_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };

        scope.currentField = getNotDestroyedFieldRnd();
        scope.setCurrentField = (index) => {
          scope.currentField = index;
        };
        scope.treeOptions = {
          dropped: function(e) {
            const fieldsIds = [];

            _.each(scope.form.form_fields_attributes, function(field) {
              if (field.id) {
                return fieldsIds.push(field.id);
              }
            });

            const source = fieldsIds[e.source.index];
            fieldsIds.splice(e.source.index, 1);
            fieldsIds.splice(e.dest.index, 0, source);

            return Widget.sortSubscribeFormFields(attrs.widgetId, fieldsIds);
          }
        };
        scope.inputTypes = [
          {
            field_type: 'text',
            name: 'Text',
            title: $filter('translate')('widget.form.fieldType1')
          }, {
            field_type: 'number',
            name: 'Number',
            title: $filter('translate')('widget.form.fieldType2')
          }, {
            field_type: 'tel',
            name: 'Phone',
            title: $filter('translate')('widget.form.fieldType3')
          }, {
            field_type: 'email',
            name: 'Email',
            title: $filter('translate')('widget.form.fieldType4')
          }, {
            field_type: 'url',
            name: 'Url',
            title: $filter('translate')('widget.form.fieldType5')
          }, {
            field_type: 'textarea',
            name: 'Text Area',
            title: $filter('translate')('widget.form.fieldType6')
          }, {
            field_type: 'select',
            name: 'Select',
            title: $filter('translate')('widget.form.fieldType7')
          }, {
            field_type: 'checkbox',
            name: 'Checkbox',
            title: $filter('translate')('widget.form.fieldType8')
          }, {
            field_type: 'radio',
            name: 'Radio',
            title: $filter('translate')('widget.form.fieldType9')
          }
        ];
        scope.add = function() {
          scope.form.form_fields_attributes.push({field_type: 'text'});

          const length = scope.form.form_fields_attributes.length;
          scope.currentField = length - 1;
          scope.setTitleAsType('text');
        };
        scope.fieldsLength = function(fields) {
          const destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        scope.remove = function() {
          scope.form.form_fields_attributes[scope.currentField]._destroy = true;
          scope.currentField = getNotDestroyedFieldRnd();
        };

        const fieldChanged = function(newVal, oldVal, fieldType) {
          var field, index, j, len1;
          for (index = j = 0, len1 = newVal.length; j < len1; index = ++j) {
            field = newVal[index];
            if (oldVal[index] && field[fieldType] !== oldVal[index][fieldType]) {
              return true;
            }
          }
          return false;
        };

        const trimNbsp = function(fields) {
          var field, j, len1;
          for (j = 0, len1 = fields.length; j < len1; j++) {
            field = fields[j];
            field.title = field.title.replace(/&nbsp;/gi, '');
          }
          return fields;
        };

        const updateFieldsByNames = function(fields, fieldsNames, newValues) {
          var field, j, len1, ref, results;
          results = [];
          for (j = 0, len1 = fields.length; j < len1; j++) {
            field = fields[j];
            if (ref = field.name, indexOf.call(fieldsNames, ref) >= 0) {
              results.push(_.extend(fields[findFieldIndexByAttr(fields, {
                name: field.name
              })], newValues));
            } else {
              results.push(void 0);
            }
          }
          return results;
        };

        const updateFieldByName = function(fields, name, newValues) {
          return _.extend(fields[findFieldIndexByAttr(fields, {
            name: name
          })], newValues);
        };

        const updateTranslations = function(fields) {
          updateFieldByName(fields, KUPON_FIELD, {
            placeholder: $filter('translate')('widget.form.yourCoupon')
          });
          updateFieldByName(fields, USER_FIELDS[1], {
            title: $filter('translate')('widget.form.middleName')
          });
          updateFieldByName(fields, USER_FIELDS[2], {
            title: $filter('translate')('widget.form.lastName')
          });
          updateFieldByName(fields, PRODUCT_PRICE_FIELD, {
            title: $filter('translate')('widget.form.product')
          });
          updateFieldByName(fields, ADDRESS_FIELD, {
            title: $filter('translate')('widget.form.delivery_address')
          });
          updateFieldByName(fields, USER_FIELDS[4], {
            title: $filter('translate')('widget.form.lead_offert_title')
          });
          updateFieldByName(fields, USER_FIELDS[5], {
            title: $filter('translate')('widget.form.offerta_accept_title')
          });
          return updateFieldByName(fields, NAME_FIELD, {
            title: $filter('translate')('widget.form.name')
          });
        };

        // Показ/скрытие поля Оплата картой (Stripe)
        if (stripeEnabled && (scope.form.product_selected || ignoreSelectedProducts)) {
          updateFieldByName(scope.form.form_fields_attributes, STRIPE_FIELD, {show: true});
        } else {
          const indexStripe = findFieldIndexByAttr(scope.data.form_fields_attributes, {name: STRIPE_FIELD});
          if (scope.data.form_fields_attributes[indexStripe].exist === false) {
            updateFieldByName(scope.form.form_fields_attributes, STRIPE_FIELD, {show: false});
          }
        }

        // Показ/скрытие поля Оплата картой (CloudPayments)
        if (cloudpaymentEnabled && (scope.form.product_selected || ignoreSelectedProducts)) {
          updateFieldByName(scope.form.form_fields_attributes, CLOUD_PAYMENTS_FIELD, {show: true});
        } else {
          const indexCloudPayment = findFieldIndexByAttr(scope.data.form_fields_attributes, {name: CLOUD_PAYMENTS_FIELD});
          const cloudPaymentAttributes = scope.data.form_fields_attributes[indexCloudPayment];
          if (cloudPaymentAttributes && cloudPaymentAttributes.exist === false) {
            updateFieldByName(scope.form.form_fields_attributes, CLOUD_PAYMENTS_FIELD, {
              show: false
            });
          }
        }

        const hasFloatingPriceProduct = function(products) {
          let floatingPriceProduct = false;
          _.each(products, function(product) {
            if (product.hasOwnProperty('name') && product.type === FLOATING_PRICE_PRODUCT) {
              floatingPriceProduct = true;
            }
            if (product.hasOwnProperty('goods') && product.goods.length > 0 && !floatingPriceProduct) {
              floatingPriceProduct = hasFloatingPriceProduct(product.goods);
            }
          });
          return floatingPriceProduct;
        };

        const getUpdatedFields = function(fields) {
          if (scope.data.product_selected) {
            updateFieldByName(fields, EMAIL_FIELD, {disable: true, exist: true});
            updateFieldByName(fields, USER_FIELDS[3], {show: false, exist: false});
            updateFieldByName(fields, CONTACT_INFO_FIELD, {show: true});
            updateFieldByName(fields, PRODUCT_PRICE_FIELD, {show: true});
            updateFieldByName(fields, KUPON_FIELD, {show: true});
            updateFieldByName(fields, ADDRESS_FIELD, {show: true, hidden: false});
            updateFieldsByNames(fields, ADDRESS_FIELDS, {show: true});
            if (stripeEnabled) {
              updateFieldByName(fields, STRIPE_FIELD, {show: true});
            } else {
              updateFieldByName(fields, STRIPE_FIELD, {show: false, exist: false});
            }
            if (cloudpaymentEnabled) {
              updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, {show: true});
            } else {
              updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, {show: false, exist: false});
            }
          } else {
            updateFieldByName(fields, EMAIL_FIELD, {disable: false});
            updateFieldByName(fields, USER_FIELDS[3], {show: true});
            updateFieldByName(fields, CONTACT_INFO_FIELD, {show: false, exist: false});
            updateFieldByName(fields, PRODUCT_PRICE_FIELD, {show: false, exist: false});
            updateFieldByName(fields, KUPON_FIELD, {show: false, exist: false});
            updateFieldByName(fields, SUM_FIELD, {show: false, exist: false});
            updateFieldByName(fields, ADDRESS_FIELD, {show: false, exist: false});
            updateFieldsByNames(fields, ADDRESS_FIELDS, {show: false, exist: false});
            updateFieldsByNames(fields, DELIVERY_ADDRESS_FIELDS, {show: false, exist: false});
            if (stripeEnabled && ignoreSelectedProducts) {
              updateFieldByName(fields, STRIPE_FIELD, {disable: true, show: true, exist: true});
            } else {
              updateFieldByName(fields, STRIPE_FIELD, {show: false, exist: false});
            }
            if (cloudpaymentEnabled && ignoreSelectedProducts) {
              updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, {disable: true, show: true, exist: true});
            } else {
              updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, {show: false, exist: false});
            }
          }

          if (ignoreSelectedProducts) {
            const kuponField = findFieldByAttr(fields, {name: KUPON_FIELD});
            updateFieldByName(fields, KUPON_FIELD, {show: true, exist: kuponField.exist});
          }

          if (disableChangeEmailField) {
            updateFieldByName(fields, EMAIL_FIELD, {disable: true, show: true, exist: true});
          }

          if (disableChangeStripeField) {
            updateFieldByName(fields, STRIPE_FIELD, {disable: true, show: true, exist: true});
          }

          if (disableChangeCloudpaymentField) {
            updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, {disable: true, show: true, exist: true});
          }

          return fields;
        };

        const removeDeletedAdditionalFields = function() {
          let needUpdate = 0;
          let defaultFields = [NAME_FIELD, EMAIL_FIELD, PRODUCT_PRICE_FIELD, ADDRESS_FIELD, STRIPE_FIELD, CLOUD_PAYMENTS_FIELD, CONTACT_INFO_FIELD, KUPON_FIELD, SUM_FIELD];
          defaultFields = defaultFields.concat(USER_FIELDS);
          defaultFields = defaultFields.concat(ADDRESS_FIELDS);
          defaultFields = defaultFields.concat(DELIVERY_ADDRESS_FIELDS);

          const formclone = angular.copy(scope.form);
          const ref = formclone.form_fields_attributes;

          for (let j = 0, len1 = ref.length; j < len1; j++) {
            const field = ref[j];
            const ref1 = field.name;
            const notDefaultFields = (indexOf.call(defaultFields, ref1) < 0);

            if (notDefaultFields) {
              const needForDestroy = (_.filter(window.justclick.additionalFields, {
                name: field.name
              })).length === 0;

              if (needForDestroy) {
                needUpdate++;
                field._destroy = true;
              }
            }
          }

          if (needUpdate > 0) {
            $rootScope.isSaveDisabled = true;

            const sectionId = blockEditDialog.getSectionId({id: formclone.id});

            return Widget.update(sectionId, formclone)
              .then(function(data) {
                scope.form.form_fields_attributes = getUpdatedFields(data.form_fields_attributes);
                $rootScope.isSaveDisabled = false;
              }).catch(function() {
                $rootScope.isSaveDisabled = false;
              });
          } else {
            return {
              then: function(cb) {
                return cb();
              }
            };
          }
        };

        const addAdditionalFields = function() {
          removeDeletedAdditionalFields().then(function() {
            let fieldsForAddingCount = 0;

            if (window.justclick.additionalFields) {
              _.each(window.justclick.additionalFields, function(field) {
                if (!fieldExist(field)) {
                  fieldsForAddingCount++;
                  scope.form.form_fields_attributes.push(field);
                }
              });
            }

            if (fieldsForAddingCount > 0 || newFieldsAdded) {
              const sectionId = blockEditDialog.getSectionId({id: scope.form.id});

              return Widget.update(sectionId, scope.form).then(function(data) {
                scope.form.form_fields_attributes = getUpdatedFields(data.form_fields_attributes);
              });
            }
          });
        };

        const updateFieldsList = function(newVal, oldVal) {
          if (newVal !== null && newVal !== oldVal) {
            const fields = getUpdatedFields(scope.form.form_fields_attributes);

            formInputsHtmlRender(fields);
          }
        };

        addAdditionalFields();
        updateTranslations(scope.form.form_fields_attributes);

        /**
         * При изменении поля ADDRESS_FIELD покажем/скроем поля DELIVERY_ADDRESS_FIELDS
         * @param newFields
         * @param oldFields
         */
        const toggleDeliveryAddressFields = function(newFields, oldFields) {
          const indexAddressField = findFieldIndexByAttr(newFields, {name: ADDRESS_FIELD});
          const indexAddressOldFields = findFieldIndexByAttr(oldFields, {name: ADDRESS_FIELD});

          if (indexAddressField > 0 && indexAddressOldFields > 0 && newFields[indexAddressField].exist !== oldFields[indexAddressOldFields].exist) {
            if (newFields[indexAddressField].exist) {
              updateFieldsByNames(newFields, DELIVERY_ADDRESS_FIELDS, {show: true, exist: true});
            } else {
              updateFieldsByNames(newFields, DELIVERY_ADDRESS_FIELDS, {show: false, exist: false});
            }
          }
        };

        // Watchers
        let listeners = [];

        listeners.push(scope.$watch('form', (newVal) => {
          if (!ngModel) {
            return false;
          }
          ngModel.$setViewValue(newVal);
        }));
        listeners.push(scope.$watch('data.button', (newVal) => {
          setButtonStyles(newVal);
        }, true));
        listeners.push(scope.$watch('data.parent_button', (newVal) => {
          setParentButtonStyles(newVal);
        }, true));
        listeners.push(scope.$watch('data.form_style', (newVal) => {
          setFormStyles(newVal);
        }, true));
        listeners.push(scope.$watch('data.form_fields_style_attributes', (newVal) => {
          setFormFieldsStyles(newVal);
        }, true));
        listeners.push(scope.$watch('data.labels_style_attributes', (newVal) => {
          setLabelsStyles(newVal);
        }, true));
        listeners.push(scope.$watch('data.form_link_style_attributes', (newVal) => {
          setLinkStyles(newVal);
        }, true));
        listeners.push(scope.$watch('data.selected_products', (newVal) => {
          if (scope.data.product_selected) {
            const fields = scope.form.form_fields_attributes;

            if (hasFloatingPriceProduct(newVal)) {
              updateFieldByName(fields, SUM_FIELD, {show: true, disable: true, exist: true});
            } else {
              updateFieldByName(fields, SUM_FIELD, {show: false, disable: false, exist: false});
            }
            if (newVal.length > 1) {
              updateFieldByName(fields, PRODUCT_PRICE_FIELD, {disable: true, exist: true});
            } else {
              updateFieldByName(fields, PRODUCT_PRICE_FIELD, {disable: false});
            }

            formInputsHtmlRender(fields);
          }
        }, true));
        listeners.push(scope.$watch('data.as_modal', (newVal) => {
          modalTransform(newVal);
        }));
        listeners.push(scope.$watch('data.form_design', (newVal) => {
          scope.form.form_design = newVal;

          formInputsHtmlRender(scope.form.form_fields_attributes);
        }));
        listeners.push(scope.$watch('data.labels', (newVal) => {
          scope.form.labels = newVal;

          formInputsHtmlRender(scope.form.form_fields_attributes);
        }));
        listeners.push(scope.$watch('form.form_fields_attributes', (newVal, oldVal) => {
          const fields = trimNbsp(newVal);
          const needForChange = (
              fieldChanged(newVal, oldVal, 'placeholder') ||
              fieldChanged(newVal, oldVal, 'options_raw') ||
              fieldChanged(newVal, oldVal, 'exist') ||
              fieldChanged(newVal, oldVal, 'hidden') ||
              fieldChanged(newVal, oldVal, 'offert_text') ||
              fieldChanged(newVal, oldVal, 'offert_url_text') ||
              fieldChanged(newVal, oldVal, 'checked')
          );

          scope.data.form_fields_attributes = fields;

          if (scope.fieldsLength(newVal) !== scope.fieldsLength(oldVal) || needForChange) {
            toggleDeliveryAddressFields(fields, trimNbsp(oldVal));
            formInputsHtmlRender(newVal);
          }
        }, true));
        listeners.push(scope.$watch('data.product_selected', (newVal, oldVal) => {
          updateFieldsList(newVal, oldVal);
        }));

        scope.$on('$destroy', () => {
          return _.each(listeners, function(listener) {
            return listener();
          });
        });
        scope.setTitleAsType = function(type) {
          var finded;
          finded = _.filter(scope.inputTypes, {
            field_type: type
          });
          scope.form.form_fields_attributes[scope.currentField].title = finded[0].title;
          return scope.form.form_fields_attributes[scope.currentField].placeholder = finded[0].title;
        };

        const emptyName = (variable) => variable || 'No name';
        const emptyDesc = (variable) => variable || '';

        const generateUrlInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='url' name='" + translit + "' class='strwf__input' placeholder='" + (emptyDesc(field.placeholder)) + "'>";
        };

        const generateEmailInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='email' name='" + translit + "' class='strwf__input' placeholder='" + (emptyName(field.placeholder)) + "'>";
        };

        const generateTextInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='text' name='" + translit + "' class='strwf__input' placeholder='" + (emptyDesc(field.placeholder)) + "'>";
        };

        const generateNumberInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='number' name='" + translit + "' class='strwf__input' placeholder='" + (emptyDesc(field.placeholder)) + "'>";
        };

        const generatePhoneInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='tel' name='" + translit + "' class='strwf__input' placeholder='" + (emptyDesc(field.placeholder)) + "'>";
        };

        const generateTextareaInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<textarea readonly='' " + required + " class='strwf__input strwf__input_textarea' name='" + translit + "' placeholder='" + (emptyDesc(field.placeholder)) + "'></textarea>";
        };

        const generateSelectInput = function(field) {
          var options, optionsHtml, required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          if (field.options_raw) {
            options = field.options_raw.split("\n");
            optionsHtml = "";
            _.each(options, function(option) {
              var selected;
              if (option === field.value) {
                selected = "selected=''";
              } else {
                selected = "";
              }
              return optionsHtml += "<option value='" + option + "' " + selected + ">" + option + "</option>";
            });
          }
          return "<select " + required + " class='strwf__input' name='" + translit + "'>" + optionsHtml + "</select>";
        };

        const generateCheckboxInput = function(field, index) {
          var optionsHtml, selected, translit;

          translit = translitService.cyrillToLatin(emptyName(field.placeholder));

          if (field.title === field.value || field.checked) {
            selected = "checked=''";
          } else {
            selected = "";
          }

          optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' name='entity[{{field.name}}]' " + selected + "><label contenteditable='false' data-access='form_fields_attributes." + index + ".title' class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + field.title + "</label></div>";
          if (field.offert) {
            optionsHtml = "<div class='strwf__offert-wrapper'><div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' name='entity[{{field.name}}]' " + selected + "><label class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + (emptyDesc(field.offert_text)) + " <a href='#'>" + (emptyDesc(field.offert_url_text)) + "</a></label></div></div>";
          } else if (field.name === ADDRESS_FIELD) {
            optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' name='entity[{{field.name}}]' " + selected + "><label class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + field.placeholder + "</label></div>";
          }
          return optionsHtml;
        };

        const generateRadioInput = function(field) {
          var options, optionsHtml, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          options = field.options_raw.split("\n");
          optionsHtml = "";
          _.each(options, function(option, index) {
            var selected;
            if (option === field.value) {
              selected = "checked=''";
            } else {
              selected = "";
            }
            return optionsHtml += "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + option + "' id='strwfr-" + field.name + "-" + index + "-1' type='radio' name='entity[" + field.name + "]' " + selected + "><label class='strwf__radio-label' for='strwfr-" + field.name + "-" + index + "-1'>" + option + "</label></div>";
          });
          return optionsHtml;
        };

        const generateProductInfo = function() {
          let optionsHtml = "";
          let {selected_products} = scope.data;

          // Выведем текст по умолчанию, если продукт не установлен
          if (selected_products.length === 0) {
            selected_products = [{
              title: $filter('translate')('modulesSettings.subscribeFormFields.product'),
              priceFormatted: $filter('translate')('modulesSettings.subscribeFormFields.cost')
            }]
          }

          optionsHtml += "<div class='subscribe-form strwf__input-wrapper'>";

          if (selected_products.length === 1) {
            const title = selected_products[0].title;
            const price = selected_products[0].priceFormatted;

            optionsHtml += "<div class='row str-row subscribe-form__products'>" +
                  "<div class='str-col str-col-6'>" +
                    "<div class='subscribe-form__title'>" + title + "</div>" +
                  "</div>" +
                  "<div class='str-col str-col-6' style='text-align: right;'>" +
                    "<div class='subscribe-form__price'>" + price + "</div>" +
                  "</div>" +
                "</div>";
          } else {
            const ref = selected_products;

            for (let j = 0, len1 = ref.length; j < len1; j++) {
              const product = ref[j];
              const title = product.title;
              const name = product.name;
              const price = product.priceFormatted;
              const radioHtml = "<div class='strwf__radio-wrapper'>" +
                  "<input class='strwf__radio' id='product-" + name + "' type='radio' name='products'>" +
                  "<label class='strwf__radio-label' for='product-" + name + "'>" + title + "</label>" +
                  "</div>";

              optionsHtml += "<div class='row str-row subscribe-form__products'>" +
                    "<div class='str-col str-col-8'>" + radioHtml + "</div>" +
                    "<div class='str-col str-col-4' style='text-align: right;'>" +
                      "<div class='subscribe-form__price'>" + price + "</div>" +
                    "</div>" +
                  "</div>";
            }
          }
          optionsHtml += "<hr></div>";

          return optionsHtml;
        };

        const generateContactInfo = function(field, index) {
          var optionsHtml;
          optionsHtml = "<div class='strwf__input-wrapper'><h5 contenteditable='false' data-access='form_fields_attributes." + index + ".title'>" + field.title + "</h5></div>";
          return optionsHtml;
        };

        const setButtonStyles = function(newVal) {
          let style;
          const button = widgetElWrapper.find(".strwf_form-button");

          scope.form.button = newVal;
          widgetElWrapper.find(ns.widgetFormButtonWrapperClass).css("text-align", newVal.style["textAlign"]);

          if (newVal.style.textAlign) {
            style = angular.copy(newVal.style);
            delete style.textAlign;
          }

          button.css(style);
          blockEditDialog.updateBtn(button, newVal);
        };

        const setParentButtonStyles = function(newVal) {
          let style;
          const button = widgetElWrapper.find(".strwf__parent-button");

          scope.form.parent_button = newVal;
          widgetElWrapper.find(ns.widgetFormParentButtonWrapperClass).css("text-align", newVal.style["textAlign"]);
          if (newVal.style.textAlign) {
            style = angular.copy(newVal.style);
            delete style.textAlign;
          }

          button.css(style);
          blockEditDialog.updateBtn(button, newVal);
        };

        const setFormFieldsStyles = function(newVal) {
          scope.form.form_fields_style_attributes = newVal;
          widgetElWrapper.find(".strwf__input").css(newVal);
        };

        const setLabelsStyles = function(newVal) {
          scope.form.labels_style_attributes = newVal;
          widgetElWrapper.find(".strwf__label").css(newVal);

          const offertWrapper = widgetElWrapper.find(".strwf__offert-wrapper");
          if (offertWrapper.length > 0) {
            offertWrapper.css(newVal);
          }
        };
        const setLinkStyles = function(newVal) {
          scope.form.form_link_style_attributes = newVal;

          const offertWrapper = widgetElWrapper.find(".strwf__offert-wrapper");
          if (offertWrapper.length > 0) {
            offertWrapper.find("a").css(newVal);
          }
        };

        const setFormStyles = function(newVal) {
          widgetElWrapper.find("form").css(newVal);
        };

        const modalTransform = function(newVal) {
          const form = widgetElWrapper.find(".strwf__form");
          const button = "<div class='" + (ns.widgetFormParentButtonWrapperClass.substr(1)) + "'><label type='submit' contenteditable='false' data-access='parent_button.value' class='strwf_button strwf__parent-button'>" + scope.form.parent_button.value + "</label></div>";

          widgetElWrapper.find("" + ns.widgetFormParentButtonWrapperClass).remove();
          if (newVal) {
            form.hide();
            widgetElWrapper.prepend(button);
            setParentButtonStyles(scope.form.parent_button);
            ContentEditable.bind(false, true, widgetId);
          } else {
            widgetElWrapper.find(".subscribe-form__modal-title").remove();
            form.show();
          }
        };

        const getExistFieldsLength = function(fields) {
          return (_.filter(fields, {
            exist: false
          })).length;
        };

        const formInputsHtmlRender = function(fields) {
          const fieldsWithLabelBlock = ['checkbox', 'radio'];
          const fieldsWithOptions = ['checkbox', 'radio', 'select'];
          const formIsHorizontal = scope.form.form_design === 'horizontal';

          let output = '';
          let inlineClasses = '';
          let buttonLabel = '';

          _.each(fields, function(field, index) {
            const ref = field.field_type;

            if (!field.options_created && indexOf.call(fieldsWithOptions, ref) >= 0 && !field.options_raw) {
              field.options_raw = "" + ($filter('translate')('modulesSettings.subscribeFormFields.variants'));
              field.options_created = true;
            }

            if (!field._destroy && field.exist && !field.hidden) {
              if (formIsHorizontal) {
                const existFieldsLength = getExistFieldsLength(fields);
                inlineClasses = 'strwf__input-inline strwf__input-wrapper_' + (scope.fieldsLength(fields) + 1 - existFieldsLength);
              }

              const ref1 = field.field_type;
              const displayBlock = (indexOf.call(fieldsWithLabelBlock, ref1) >= 0) ? 'strwf__label_block' : '';
              const styleForHorizontalCheckbox = 'order: 1; margin-top: .8%; flex: 1 1 100%;';

              output += `<div class="strwf__input-wrapper ${inlineClasses}" ${formIsHorizontal && field.field_type === 'checkbox' ? `style="${styleForHorizontalCheckbox}"` : ''}>`;

              if (scope.form.labels && !field.offert && field.name !== ADDRESS_FIELD) {
                output += "<label class='strwf__label " + displayBlock + "' contenteditable='false' data-access='form_fields_attributes." + index + ".title'>" + (emptyDesc(field.title)) + "</label>";
                buttonLabel = formIsHorizontal ? "<div class='strwf__label'>​</div>" : "";
              }

              switch (field.field_type) {
                case 'text':
                  output += generateTextInput(field);
                  break;
                case 'number':
                  output += generateNumberInput(field);
                  break;
                case 'textarea':
                  output += generateTextareaInput(field);
                  break;
                case 'select':
                  output += generateSelectInput(field);
                  break;
                case 'checkbox':
                  output += generateCheckboxInput(field, index);
                  break;
                case 'radio':
                  output += generateRadioInput(field);
                  break;
                case 'tel':
                  output += generatePhoneInput(field);
                  break;
                case 'email':
                  output += generateEmailInput(field);
                  break;
                case 'url':
                  output += generateUrlInput(field);
              }
              output += "<span id='" + field.nameEn + "' class='error-text'></span></div>";
            }

            if (!field._destroy && field.exist && field.controlling) {
              switch (field.name) {
                case PRODUCT_PRICE_FIELD:
                  output += generateProductInfo();
                  break;
                case CONTACT_INFO_FIELD:
                  output += generateContactInfo(field, index);
                  break;
              }
            }
          });

          const button = (
              "<div class='strwf__button-wrapper strwf__form-button__wrapper " + inlineClasses + "'>" +
                buttonLabel +
                "<label type='submit' class='strwf_button strwf_form-button' contenteditable='false' data-access='button.value'>" +
                  scope.form.button.value +
                "</label>" +
              "</div>"
          );

          if (formIsHorizontal) {
            widgetElWrapper.find("form").css({display: 'flex', 'flex-wrap': 'wrap'});
          } else {
            widgetElWrapper.find("form").css({display: 'block'});
          }

          widgetElWrapper.find("form").html('');
          widgetElWrapper.find("form").append(output);
          widgetElWrapper.find("form").append(button);

          setButtonStyles(scope.data.button);
          setFormFieldsStyles(scope.data.form_fields_style_attributes);
          setLabelsStyles(scope.data.labels_style_attributes);
          setLinkStyles(scope.data.form_link_style_attributes);

          ContentEditable.bind(false, true, widgetId);
        };

        updateFieldsList(scope.data.product_selected);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/subscribeFormfields/subscribeFormfields.directive.js